import { Card } from "@/types/v2";
import { useFeature } from "@/hooks/useFeatures";
import { FEATURE_FLAGS } from "@/types/v2/FeatureFlag";
import { RoMetricsSection } from "@/components/Common/RoDetailsPanel/RoMetricsSection";
import { RoTimeInShopBar } from "@/components/Common/RoDetailsPanel/RoTimeInShopBar";
import { RoTasksSection } from "@/components/Tasks/RoTasksSection";

export interface RoMetricsTasksShellsProps {
  cardData: Card;
}

export const RoMetricsTasksShells = ({
  cardData,
}: RoMetricsTasksShellsProps) => {
  const isTasksTabEnabled = useFeature(FEATURE_FLAGS.isTasksTabEnabled);

  return (
    <div className="flex flex-col gap-4">
      <RoMetricsSection cardData={cardData} />
      {isTasksTabEnabled && <RoTasksSection cardId={cardData.id} />}
      <RoTimeInShopBar cardData={cardData} />
    </div>
  );
};
